var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0517578,
    y: 0.232422,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#EF4B4B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4133_6240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75244 11.4325L13.0004 15.0325L19.2483 11.4325L13.0004 7.83252L6.75244 11.4325Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2483 11.4326V17.4326M19.2483 17.4326C19.2483 17.7509 19.102 18.0561 18.8416 18.2811C18.5813 18.5062 18.2281 18.6326 17.8599 18.6326H8.14087C7.77264 18.6326 7.41948 18.5062 7.1591 18.2811C6.89872 18.0561 6.75244 17.7509 6.75244 17.4326M19.2483 17.4326L15.083 13.8326M6.75244 17.4326V11.4326M6.75244 17.4326L10.9177 13.8326",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4133_6240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12,
    fill: "white",
    transform: "translate(6.05176 7.23242)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.5576d88372ded83f41d8f090f27a80c9.svg";
export { ForwardRef as ReactComponent };